import React from 'react';
import ListView from '../Common/Views/ListView';

const LocationList = ({
    filters = {},
    addButton = true,
    searchBox = true,
    onSelect = null, // a function to override the table row click action (default is to navigate to details page)
    columns = null, // array if specific columns from the columnsConfig to show in the list view. If null, all columns will be shown.
}) => {

    // Columns configuration for rendering location list
    const columnsConfig = {
        name: {
            key: 'name',
            label: 'Name',
            render: row => row.name
        },
        type: {
            key: 'type',
            label: 'Type',
            render: row => row.type
        },
        phoneNumber: {
            key: 'phoneNumber',
            label: 'Phone number',
            render: row => row.phoneNumber
        },
        address: {
            key: 'address',
            label: 'Address',
            render: row => row.address
        },
        hasOutlet: {
            key: 'hasOutlet',
            label: 'Outlet',
            render: row => row.hasOutlet ? 'Yes' : 'No'
        },
    };

    return <ListView
        title="Locations"
        apiPath="/tenants/locations"
        filters={filters}
        addButton={addButton}
        addButtonLabel="Add new location"
        addPath="/locations/add"
        rowClickPath={(item) => `/locations/${item.id}`}
        onSelect={onSelect}
        columnsConfig={columnsConfig}
        columns={columns}
        searchBox={searchBox}
        searchAttributes={[
            { name: 'name', label: 'Name', type: 'text' },
            { name: 'phoneNumber', label: 'Phone number', type: 'text' },
        ]}
        noResultsMessage="No locations found"
    />
};

export default LocationList;